import { Check, ReportProblem } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";
import { useAppStore } from "../../../hooks/useStores";
import BriaLogo from "../BriaLogo/BriaLogo";
import styles from "./PluginLoginStatus.module.scss";

const PluginLoginStatus = observer(() => {
	const location = useLocation();
	const { t } = useTranslation();
	const { authStore } = useAppStore();

	const successMessage = location.state?.success === true;

	useEffect(() => {
		authStore.isPluginAuth = false;
		authStore.pluginAuthId = undefined;
	}, [authStore]);

	return (
		<Box className={styles.wrapper}>
			<Box className={styles.logo}>
				<BriaLogo />
			</Box>

			<Box className={styles.content}>
				<Box
					className={clsx(styles.alertIcon, {
						[styles.success]: successMessage,
						[styles.error]: !successMessage,
					})}
					role="alert"
				>
					{successMessage ? <Check fontSize="large" /> : <ReportProblem fontSize="large" />}
				</Box>

				<Typography component="div" className={styles.messageContent}>
					{successMessage ? (
						<span>{t("pluginSuccessLogin")}</span>
					) : (
						<>
							<span>{t("pluginFailedLogin.message1")}</span>
							<Link to={RouterConstants.USERS.fullPath} className={styles.inlineLink}>
								{t("pluginFailedLogin.admin")}
							</Link>
							<span>{t("pluginFailedLogin.message2")}</span>
							<Link
								to="#"
								className={styles.inlineLink}
								onClick={(e) => {
									e.preventDefault();
									window.open(LinkConstants.CONTACT_US_FORM_LINK, "_blank", "noopener,noreferrer");
								}}
							>
								{t("pluginFailedLogin.briaSupport")}
							</Link>
							<span>{t("pluginFailedLogin.message3")}</span>
						</>
					)}
				</Typography>
			</Box>
		</Box>
	);
});

export default PluginLoginStatus;
